import api from '../../../store/config/api';
import { CONTACT as SCHEMA } from '../../../schemas';

export const [
  GET_APP_CONTACT,
  GET_APP_CONTACT_REQUEST,
  GET_APP_CONTACT_SUCCESS,
  GET_APP_CONTACT_FAILURE
] = api.buildTypes('GET_APP_CONTACT');

export const APP_NAME = 'contact';

function getContact({
  action,
  name = APP_NAME,
  version = 'v1',
  ...query
} = {}) {
  if (!action) throw `Action type required`; // eslint-disable-line no-throw-literal
  return {
    type: GET_APP_CONTACT,
    payload: {
      url: `/apps/${name}/${action}/${version}`,
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: query
      }
    }
  };
}

export function getContactByEmail(options = {}) {
  return getContact({ ...options, action: 'email' });
}

export function getContactByPhone(options = {}) {
  return getContact({ ...options, action: 'phone' });
}



// WEBPACK FOOTER //
// ./js/actions/api/apps/contact.js